@if (showEnvironmentBanner()) {
  <div
    class="sticky top-0 z-50 w-full bg-vinciYellow-400 px-4 py-2 text-center text-[0.75rem]/[1rem] font-bold tracking-[0.08em] text-vinciBlue-600 uppercase relative"
  >
    {{ "app.environmentBanner" | transloco: { environment: environmentLabel() } }}
    <button
      type="button"
      class="absolute right-3 top-1/2 -translate-y-1/2 rounded px-2 py-0.5 text-base leading-none hover:cursor-pointer hover:bg-vinciYellow-300"
      [attr.aria-label]="'components.modal.close' | transloco"
      (click)="closeEnvironmentBanner()"
    >
      x
    </button>
  </div>
}

@if (!isErrorPage()) {
  <app-header class="relative z-10 transition-opacity duration-200" [class.pointer-events-none]="modalService.isAnyOpen()" [class.blur-[2px]]="modalService.isAnyOpen()"></app-header>
}

<div class="relative px-6 overflow-x-hidden">
  <div class="max-w-[78rem] mx-auto my-0">
    <app-breadcrumb></app-breadcrumb>
    <router-outlet />
    <feedback-prompt />
  </div>
</div>

@if (!isErrorPage()) {
  <app-footer></app-footer>
}

@if (errorModalService.isOpen()) {
  <app-modal
    [title]="errorModalService.state().title"
    [image]="errorModalService.state().image"
    [text]="errorModalService.state().text"
    [showClose]="errorModalService.state().showClose"
    [type]="errorModalService.state().type"
    [buttonText]="errorModalService.state().buttonText"
    (completeModal)="closeErrorModal()"
    (closeModal)="closeErrorModal()"
    class="w-max"
  >
  </app-modal>
}
